import React, { Component }  from 'react';
import { NavLink } from 'react-router-dom';
import "../App.css";
import "../index.css";
import Title from './Title';
import Snow from './Snow';

class Home extends Component{

    constructor(){
        super();
        this.contactRef = React.createRef()  

        this.state = { open : false,
                       pulse : true,
                       scale : "h-screen w-screen",
                       moveIn : false   
                    };
    }

    mount(){
      setTimeout(() => {
        this.setState({
          scale : "h-screen w-screen transition duration-1000 ease-in-out transform scale-105"
       })
      }, 200);
    }

    componentDidMount(){
         this.mount();
    }

    MenuButton = () => {
        this.setState({
            open : !this.state.open,
            pulse : !this.state.pulse,
            moveIn : !this.state.moveIn
        })
    }

    
  

    render(){
      return (
          <main>
            <Snow></Snow>
            <Title></Title>

            <div className={this.state.scale}>

              <div 
              id="title" 
              className="text-white text-center text-4xl md:text-6xl my-3 md:my-8">

                <div className="font-black p-5 md:p-16 animate-fade-in-down w-full text-center flex flex-row justify-between gap-12">
                  
                  <h3
                    className="font-mono p-5 text-2xl md:text-5xl leading-loose">
                    “The technology you use impresses no one. The experience you create with it is everything.”
                  </h3>
                </div>

              <div className="flex flex-col justify-center items-center gap-10 shadow-2xl ">

              <div 
                  className="text-4xl hidden md:block">
                    <NavLink 
                    to ="/about" 
                    className="text-white mx-auto rounded font-black leading-loose tracking-widest ">
                      My personal biography
                    </NavLink>
                  </div>

              <div 
                  className="text-4xl hidden md:block">
                    <NavLink 
                    to ="/bestwork" 
                    className="text-white mx-auto rounded font-black leading-loose tracking-widest ">
                      Best projects so far
                    </NavLink>
                  </div>


                  <div 
                  className="text-4xl hidden md:block">
                    <NavLink 
                    to ="/currentwork" 
                    className="text-white mx-auto rounded font-black leading-loose tracking-widest ">
                      Current work
                    </NavLink>
                  </div>

              
                  <div 
                  className="text-4xl hidden md:block">
                    <NavLink 
                    to ="/projects" 
                    className="text-white mx-auto rounded font-black leading-loose tracking-widest ">
                      All projects
                    </NavLink>
                  </div>

                  <div 
                  className="text-4xl hidden md:block">
                    <NavLink 
                    to ="/contact" 
                    className="text-white mx-auto rounded font-black leading-loose tracking-widest ">
                      Contact
                    </NavLink>
                  </div>

               </div>

              </div>

            <div 
            className="h-1/6 font-mono text-white flex justify-center items-center">

                <button 
                onClick={this.MenuButton}
                className={this.state.pulse ? "visible md:hidden fa fa-bars font-black mb-5 animate-pulse text-white bg-gray-900 opacity-80 leading-loose w-2/6 md:w-1/12 rounded text-4xl md:text-5xl" : 
                "fa fa-arrow-right font-black mb-5 outline-none text-white bg-gray-900 opacity-80 leading-loose w-2/6 md:w-1/12 rounded text-4xl md:text-5xl"} >
                
                </button>
    
                <div 
                className= {this.state.open ? "text-white text-2xl md:text-4xl text-center" : "hidden"}>
                
                  <div 
                  className="bg-gray-900 opacity-90 ml-5 p-1 mb-2 w-full ">
                    <NavLink 
                    to ="/about" 
                    className="text-white mx-auto hover:bg-gray-800 rounded fa fa-id-card-o font-black">
                    
                    </NavLink>
                  </div>

                  <div 
                  className="bg-gray-900 opacity-90 ml-5 p-1 mb-2 w-full">
                    <NavLink 
                    to ="/projects" 
                    className="fa fa-area-chart font-black text-white mx-auto hover:bg-gray-800 rounded">
                    
                    </NavLink>
                  </div>

                  <div 
                  className="bg-gray-900 opacity-90 ml-5 p-1 mb-2 w-full">
                    <NavLink 
                    to ="/contact" 
                    className="font-black text-white mx-auto hover:bg-gray-800 fa fa-envelope-open-o rounded">
                    
                    </NavLink>
                  </div>
    
              </div>
            </div>

          
            </div>

          </main>

        )
      }
}

export default Home;